/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The SchoolTermCreateForm model module.
   * @module basic/model/SchoolTermCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>SchoolTermCreateForm</code>.
   * @alias module:basic/model/SchoolTermCreateForm
   * @class
   * @param companyId {Integer} company id
   * @param code {String} 编号
   * @param name {String} 名称
   * @param startDate {Date} 开始日期
   * @param endDate {Date} 结束日期
   */
  var exports = function(companyId, code, name, startDate, endDate) {
    var _this = this;

    _this['companyId'] = companyId;
    _this['code'] = code;
    _this['name'] = name;
    _this['startDate'] = startDate;
    _this['endDate'] = endDate;
  };

  /**
   * Constructs a <code>SchoolTermCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:basic/model/SchoolTermCreateForm} obj Optional instance to populate.
   * @return {module:basic/model/SchoolTermCreateForm} The populated <code>SchoolTermCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'companyId')) {
        obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'startDate')) {
        obj['startDate'] = ApiClient.convertToType(data['startDate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'endDate')) {
        obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
      }
    }
    return obj;
  }

  /**
   * company id
   * @member {Integer} companyId
   */
  exports.prototype['companyId'] = undefined;
  /**
   * 编号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 开始日期
   * @member {Date} startDate
   */
  exports.prototype['startDate'] = undefined;
  /**
   * 结束日期
   * @member {Date} endDate
   */
  exports.prototype['endDate'] = undefined;



  export default exports;
;


